export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11110.79db5e75.jpg";